import {
	Checkbox,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	TableSortLabel,
	Tooltip,
} from '@material-ui/core';
import { Delete, Phone } from '@material-ui/icons';
import Email from '@material-ui/icons/Email';
import React, { useEffect, useState } from 'react';
import LeadsItem from './LeadsItem';
import styles from './LeadsTable.module.scss';

const LeadsTable = ({ leads, search }) => {
	const [selected, setSelected] = useState();
	const [page, setPage] = useState(0);
	const [dense, setDense] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [order, setOrder] = useState('asc');
	const [orderBy, setOrderBy] = useState('calories');
	const [leadsList, setLeadsList] = useState();
	const [filteredLeads, setFilteredLeads] = useState();

	//search functionality
	useEffect(() => {
		const filtered = leads?.filter(
			(lead) =>
				lead.email?.toLowerCase().includes(search.toLowerCase()) ||
				lead.sentEmail?.toLowerCase().includes(search.toLowerCase())
		);
		setFilteredLeads(filtered);
	}, [search, leads]);

	const headCells = [
		{ id: 'email', label: 'Email' },
		{ id: 'status', label: 'Status' },
		{ id: 'phoneNumber', label: 'Phone Number' },
	];

	const descendingComparator = (a, b, orderBy) => {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	};

	const getComparator = (order, orderBy) => {
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	};

	const stableSort = (array, comparator) => {
		console.log('array', array);
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis.map((el) => el[0]);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleRequestSort = (property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};
	//
	// const emptyRows =
	// 	rowsPerPage - Math.min(rowsPerPage, leads?.length - page * rowsPerPage);

	return (
		<TableContainer className={styles.leadsTable}>
			<Table>
				<TableHead>
					<TableRow>
						{headCells.map((headCell) => (
							<TableCell key={headCell.id}>
								<TableSortLabel
									active={orderBy === headCell.id}
									direction={
										orderBy === headCell.id ? order : 'asc'
									}
									onClick={() => {
										handleRequestSort(headCell.id);
									}}
									className={styles.header_label}
								>
									{headCell.label}
								</TableSortLabel>
							</TableCell>
						))}
						<TableCell>
							<TableSortLabel className={styles.header_label}>
								Contact
							</TableSortLabel>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{filteredLeads &&
						stableSort(filteredLeads, getComparator(order, orderBy))
							.slice(
								page * rowsPerPage,
								page * rowsPerPage + rowsPerPage
							)
							.map((row, index) => {
								return (
									<LeadsItem
										key={row.email}
										row={row}
										index={index}
										styles={styles}
									/>
								);
							})}
				</TableBody>
			</Table>
			<TablePagination
				rowsPerPageOptions={[5, 10]}
				component='div'
				count={leads.length}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
				labelRowsPerPage={
					<div style={{ color: 'var(--text-high-emphasis)' }}>
						Rows per page
					</div>
				}
				nextIconButtonProps={{
					style: {
						padding: '0px',
					},
				}}
				backIconButtonProps={{
					style: {
						padding: '0px',
						marginLeft: '-10px',
					},
				}}
				SelectProps={{
					style: {
						border: '1px solid var(--text-mid-emphasis)',
						borderRadius: '4px',
						padding: '4px',
						marginRight: '10px',
					},
				}}
			/>
		</TableContainer>
	);
};

export default LeadsTable;
